<template>
	<div id="tu-information-bio">
		<el-dialog
	    v-model="dialogVisible"
	    :title="$t('noun.edit-your-bio')"
	    width="42%"
	  >
	  	<p class="p">{{ $t('verify-string.information-bio-node1') }}</p>
        <p class="p" style="font-weight: 600">{{ $t('verify-string.information-bio-node2') }}:</p>
        <p class="p">
        	<div>{{ $t('verify-string.information-bio-node3') }}</div>
        	<div>{{ $t('verify-string.information-bio-node4') }}</div>
        	<div>{{ $t('verify-string.information-bio-node5') }}</div>
        	<div>{{ $t('verify-string.information-bio-node6') }}</div>
        	<div>{{ $t('verify-string.information-bio-node7') }}</div>
        </p>
	  	<el-input v-model="content" :placeholder="$t('noun.bio')" :rows="13" type="textarea" />
	    <template #footer>
	      <span class="dialog-footer">
	        <el-button @click="dialogVisible = false">{{ $t('cancel') }}</el-button>
	        <el-button type="primary" @click="handleSaveOperation">{{ $t('Save') }}</el-button>
	      </span>
	    </template>
	  </el-dialog>
	</div>
</template>
<script>
import TeacherApi from '@/api/teacher'

export default {
	name: "tu-information-bio",
	props: {
		profile: {
			type: Object,
			default: function() {
				return {}
			}
		}
	},
	components: {
		
	},
	data() {
		return {
			dialogVisible: false,
			content: ''
		}
	},
	watch: {
		profile() {
			this.content = this.profile.bio || ''
		}
	},
	created() {
		
	},
	methods: {
		open() {
			this.dialogVisible = true;
		},
		handleSaveOperation() {
			if(!!!this.content) {
				this.$message.error(this.$t('verify-string.relevant-information-is-required'));
				return ;
			}
			let params = {
				bio: this.content
			}
			TeacherApi.store(params).then(res => {
				this.$emit('change', {name: 'bio', content: this.content});
				this.$message.success(this.$t('Save Success'));
				this.dialogVisible = false;
			})
		}
	}
}
</script>
<style lang="less">
#tu-information-bio {
	.el-dialog {
		.el-dialog__body {
			padding-top: 5px;
		}
	}

	.description {
		color: var(--el-color-info);
		padding: 5px;
	}

	.el-dialog__footer {
		text-align: center;
	}

	.p {
		line-height: 1.5;
	}
}
</style>